import { ConversationHistoryDrawer } from "../ConversationHistoryDrawer";
import { useState } from "react";
import { PanelLeft, SquarePen } from "lucide-react";
import { useAppSelector } from "@/redux/hooks";
import { getCartCounts } from "@/redux/selectors";
import { StoreShoppingBagIcon } from "@/components/StoreComponents/StoreShoppingBagIcon";
import { useCheckoutDrawer } from "@/components/Checkout/useCheckoutDrawer";

interface ConciergeHeaderProps {
  onMenuToggle?: () => void;
  onComposeClick?: () => void;
  onConversationSelect?: (conversationId: string) => void;
  showComposeIcon?: boolean;
}

export const ConciergeHeader = ({
  onMenuToggle,
  onComposeClick,
  onConversationSelect,
  showComposeIcon = true,
}: ConciergeHeaderProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const cartCount = useAppSelector(getCartCounts);
  const { openDrawer } = useCheckoutDrawer();

  const handleMenuToggle = () => {
    setIsDrawerOpen(!isDrawerOpen);
    onMenuToggle?.();
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const handleConversationSelect = (conversationId: string) => {
    onConversationSelect?.(conversationId);
  };

  const handleBagClick = () => {
    openDrawer();
  };

  return (
    <>
      <header className="tw:flex tw:items-center tw:justify-between tw:py-3 tw:px-4 tw:lg:px-0 tw:mx-auto tw:w-full tw:max-w-[900px]">
        <div className="tw:flex tw:items-center tw:gap-2 ">
          <button
            onClick={handleMenuToggle}
            aria-label="Toggle conversation history"
            className="tw:inline-flex tw:h-9 tw:w-9 tw:items-center tw:rounded-lg tw:transition-colors tw:cursor-pointer"
          >
            <PanelLeft size={20} strokeWidth={2} />
          </button>
          <button
            onClick={onComposeClick}
            className="tw:text-lg tw:font-semibold tw:no-underline hover:tw:underline tw:cursor-pointer"
          >
            Concierge
          </button>
        </div>
        <div className="tw:flex tw:items-center tw:gap-2">
          {cartCount > 0 && showComposeIcon && (
            <button
              onClick={handleBagClick}
              aria-label="View shopping bag"
              className="tw:inline-flex tw:h-9 tw:w-9 tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer"
            >
              <StoreShoppingBagIcon sx={{ fontSize: 20 }} count={cartCount} />
            </button>
          )}
          {showComposeIcon && (
            <button
              onClick={onComposeClick}
              aria-label="Compose new message"
              className="tw:inline-flex tw:h-9 tw:w-9 tw:items-center tw:justify-center tw:rounded-lg tw:transition-colors tw:cursor-pointer"
            >
              <SquarePen size={20} strokeWidth={2} />
            </button>
          )}
        </div>
      </header>

      <ConversationHistoryDrawer
        open={isDrawerOpen}
        onClose={handleDrawerClose}
        onConversationSelect={handleConversationSelect}
      />
    </>
  );
};
